
import React from 'react';

const StandardRow = ({ label, desc }: { label: string, desc: string }) => (
  <tr className="border-b border-slate-100">
    <td className="py-6 pr-8 text-xs font-black uppercase tracking-[0.2em] text-slate-900 align-top w-1/3">{label}</td>
    <td className="py-6 text-sm text-slate-500 leading-relaxed">{desc}</td>
  </tr>
);

const Security: React.FC = () => {
  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mb-24">
          <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400 mb-8">Military-grade protection</div>
          <h1 className="text-6xl font-black text-slate-900 mb-8 tracking-tighter">Security & Data Integrity Protocol</h1>
          <p className="text-xl text-slate-600 font-medium leading-relaxed">
            Zero-leak standards for data integrity and institutional shielding. We prioritize the protection of the right to know over bureaucratic compliance.
          </p>
        </div>

        <div className="bg-white border border-slate-200 p-0 mb-32">
          <table className="w-full text-left">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="px-10 py-6 text-[10px] font-bold uppercase tracking-[0.4em] text-slate-400">Protocol Layer</th>
                <th className="px-10 py-6 text-[10px] font-bold uppercase tracking-[0.4em] text-slate-400">Operational Standard</th>
              </tr>
            </thead>
            <tbody className="px-10">
              <tr>
                <td className="px-10 py-8 text-xs font-black uppercase tracking-[0.2em] text-slate-900 align-top">Forensic Grade</td>
                <td className="px-10 py-8 text-sm text-slate-500 leading-relaxed">All evidence handling follows strict chain-of-custody practices, documented via cryptographic hashing and immutable logging.</td>
              </tr>
              <tr className="bg-slate-50/50">
                <td className="px-10 py-8 text-xs font-black uppercase tracking-[0.2em] text-slate-900 align-top">Legal Safe Harbor</td>
                <td className="px-10 py-8 text-sm text-slate-500 leading-relaxed">Centralizing data servers in jurisdictions with robust privacy laws and First Amendment equivalent protections to buffer against "regulatory drift."</td>
              </tr>
              <tr>
                <td className="px-10 py-8 text-xs font-black uppercase tracking-[0.2em] text-slate-900 align-top">Operational Security (OPSEC)</td>
                <td className="px-10 py-8 text-sm text-slate-500 leading-relaxed">Analysts utilize the "Principle of Least Privilege" (PoLP) with background-verified credentials and multi-factor authentication (MFA).</td>
              </tr>
              <tr className="bg-slate-50/50">
                <td className="px-10 py-8 text-xs font-black uppercase tracking-[0.2em] text-slate-900 align-top">Data Destruction</td>
                <td className="px-10 py-8 text-sm text-slate-500 leading-relaxed">Post-audit raw data is subject to DoD-level secure erasure (5220.22-M), ensuring no residual forensic traces remain on storage media.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="p-16 bg-slate-900 text-white rounded-none relative overflow-hidden">
            <div className="relative z-10 max-w-2xl">
                <h3 className="text-3xl font-black uppercase tracking-tighter mb-8">Encryption Standard</h3>
                <div className="space-y-6">
                    <div>
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-500 mb-2">In Transit</div>
                        <p className="font-mono text-sm text-slate-300">TLS 1.3 with Perfect Forward Secrecy (PFS)</p>
                    </div>
                    <div>
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-500 mb-2">At Rest</div>
                        <p className="font-mono text-sm text-slate-300">AES-256-GCM (Military-grade symmetric encryption)</p>
                    </div>
                </div>
            </div>
            <i className="fas fa-shield-halved absolute right-0 bottom-0 text-[20rem] text-white/5 pointer-events-none translate-x-1/4 translate-y-1/4"></i>
        </div>
      </div>
    </div>
  );
};

export default Security;
